import { useSessionContext } from '@Containers/SessionContainer';
import { cn } from '@Core/Helpers';
import CmsLoader from '@Modules/CMS/CmsLoader';
import React, { useState } from 'react';
import { NavLink, useNavigate } from "react-router";
import { Flex } from "@Components/Layout/Flex";
import { Gauge, Pencil, Tag } from 'lucide-react';

export default function Sidebar() {
    const [menuShown, setMenuShown] = useState(false);
    const [loggingOut, setLoggingOut] = useState(false);
    const navigate = useNavigate();
    const { logout } = useSessionContext();

    const doLogout = async () => {
        setLoggingOut(true);

        await logout(navigate);
    };

    return (
        <div className={`
            bg-slate-900
            lg:h-full lg:fixed lg:w-60
            xl:w-1/5
            2xl:w-1/4
            ${menuShown ? 'fixed top-0 w-full h-full overflow-auto z-50' : ''}
        `}>
            <Flex className="
                justify-between h-full p-8 flex-col
                sm:flex-row
                lg:py-16 lg:flex-col lg:text-right
                xl:px-10
                2xl:px-16
            ">
                <Flex className="justify-between sm:block">
                    <NavLink
                        to="/"
                        className="text-gray-200 text-xl"
                        onClick={() => { setMenuShown(false); return true; }}
                    >
                        Admin.Juje
                    </NavLink>

                    <button
                        className="w-4 sm:hidden cursor-pointer"
                        onClick={() => { setMenuShown(!menuShown); }}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 448 512"
                            className={`fill-gray-200` + (menuShown ? ' hidden' : '')}
                        >
                            <path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/>
                        </svg>

                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 384 512"
                            className={`fill-gray-200` + (menuShown ? '' : ' hidden')}
                        >
                            <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                        </svg>
                    </button>
                </Flex>

                {/*Menu*/}
                <div>
                    <div className={cn(
                        'text-gray-300 gap-3 mt-6',
                        'sm:inline-grid sm:grid-flow-col sm:mt-0',
                        'lg:grid-flow-row lg:text-left',
                        menuShown ? 'grid' : 'hidden',
                    )}>
                        <span>
                            <NavLink
                                to="/"
                                className={({ isActive }) => cn(
                                    'hover:underline inline-flex gap-2 items-center px-3',
                                    isActive && 'bg-slate-800 rounded',
                                )}
                                onClick={() => { setMenuShown(false); return true; }}
                            >
                                <Gauge size={16} />
                                Dashboard
                            </NavLink>
                        </span>

                        <span className="text-xs mt-5 sm:max-lg:hidden px-3 inline-flex gap-1 items-center">
                            CMS
                            <CmsLoader />
                        </span>

                        <span>
                            <NavLink
                                to="/blog/posts"
                                className={({ isActive }) => cn(
                                    'hover:underline inline-flex gap-2 items-center px-3',
                                    isActive && 'bg-slate-800 rounded',
                                )}
                                onClick={() => { setMenuShown(false); return true; }}
                            >
                                <Pencil size={16} />
                                Posts
                            </NavLink>
                        </span>

                        <span>
                            <NavLink
                                to="/blog/tags"
                                className={({ isActive }) => cn(
                                    'hover:underline inline-flex gap-2 items-center px-3',
                                    isActive && 'bg-slate-800 rounded',
                                )}
                                onClick={() => { setMenuShown(false); return true; }}
                            >
                                <Tag size={16} />
                                Tags
                            </NavLink>
                        </span>
                    </div>
                </div>

                <div className={`mt-8 ${menuShown ? '' : 'hidden'} sm:block sm:mt-0`}>
                    <button
                        onClick={doLogout}
                        disabled={loggingOut}
                        className={`
                            bg-slate-700 text-gray-100 py-1 px-3 rounded text-sm
                            ${!loggingOut && 'cursor-pointer'}
                        `}
                    >
                        {loggingOut && (
                            <svg
                                className="mr-3 -mt-1 size-5 animate-spin text-white inline-block"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <circle
                                    className="opacity-25" cx="12" cy="12" r="10"
                                    stroke="currentColor" strokeWidth="4"
                                ></circle>
                                <path
                                    className="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                            </svg>
                        )}
                        Logout
                    </button>
                </div>
            </Flex>
        </div>
    );
}
